import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation, Trans } from 'react-i18next';
import DrawerWrapper from '../../common/DrawerWrapper';
import CommentsWrapper from '../../common/CommentsWrapper';
import TermActions from '../../contracts/viewTermRevision/TermActions';
import { css } from 'react-emotion';
import { withSnackbar } from '../../snackbar/Snackbar';
import { textOverflowEllipsisStyle } from '../../common/CommonCss';
import TermInfo from '../../contracts/viewTermRevision/TermInfo';
import { selectors as identitySelectors } from '../../../reducers/identities';
import { getPricingArchVersion } from '../../../../src/services/PricingArchInfo';
import { PRICING_ARCH_V2 } from '../../../constants/priceArchs';

const buttonStyle = css`
  margin-right: 5px;
`;

class TermInfoDrawer extends Component {
  static propTypes = {
    termRevision: PropTypes.object.isRequired,
    latestRevisionId: PropTypes.number.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      isFulfillerMovedToV2: false
    };
  }

  onOpenDrawer = () => {
    const fulfillerData = this.props.fulfillersById[this.props.termRevision.seller.id];
    if (fulfillerData) {
      this.fetchPricingArchVersionForFulfiller(fulfillerData.accountId);
    }
  };

  fetchPricingArchVersionForFulfiller = fulfillerAccountId => {
    getPricingArchVersion(fulfillerAccountId).then(pricingArchForFulfiller => {
      if (pricingArchForFulfiller === PRICING_ARCH_V2) {
        this.setState({ isFulfillerMovedToV2: true });
      } else {
        this.setState({ isFulfillerMovedToV2: false });
      }
    });
  };

  render() {
    const { t, termRevision, latestRevisionId, children } = this.props;
    const { isFulfillerMovedToV2 } = this.state;

    return (
      <div>
        <DrawerWrapper
          header={
            <div style={{ width: '90%' }}>
              <h3 className={textOverflowEllipsisStyle}>
                {termRevision.additionalData.name} ({t('common:commonTerminology.revision')}{' '}
                <b>{termRevision.revisionId}</b>)
              </h3>
            </div>
          }
          drawerChildren={
            <div>
              <TermInfo
                termRevision={termRevision}
                latestRevisionId={latestRevisionId}
                isLayoutVertical={true}
                editable={!isFulfillerMovedToV2}
              />
              <CommentsWrapper termId={termRevision.termId} />
            </div>
          }
          footer={
            termRevision.revisionId === latestRevisionId ? (
              <TermActions termRevision={termRevision} buttonStyle={buttonStyle} showViewMoreLink={true} />
            ) : (
              <i>
                <Trans i18nKey="contractInfo:notTheLatestRevisionText">
                  This revision is read-only since this is not the latest revision.
                  <a href={`/${termRevision.termId}/${latestRevisionId}`}>Click here to view the latest revision</a>
                </Trans>
              </i>
            )
          }
          onOpenDrawer={this.onOpenDrawer}
          closeOnClickOutside={true}>
          {children}
        </DrawerWrapper>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  fulfillersById: identitySelectors.getFulfillersById(state)
});

export default withSnackbar(connect(mapStateToProps)(withTranslation()(TermInfoDrawer)));
